import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEye, FiRefreshCcw } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import {  formatDateOnly } from "../../utils/options";

import ShowStatus from "../../utils/ShowStatus";

import { TbLibrary } from "react-icons/tb";

const StudentTable = ({ students }) => {
  const [saveData, setSaveData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [status, setStatus] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);
  useEffect(() => {
    setSaveData(students || []);
  }, [students]);

  const columns = [
    {
      accessorKey: "actions",
      header: () => "Actions",
      cell: ({ row }) => {
        const id = row.original.id;
        const status = row.original.subscription_status;

        return (
          <div className="d-flex gap-2">
            <span
              className="cursor-pointer"
              title="Update Status"
              onClick={() => {
                const rowData = row.original;

                setSelectedId(rowData.id);
                setStatus(Number(rowData.subscription_status));
                setSelectedStudent(rowData);
                setShowPopup(true);
              }}
            >
              <FiRefreshCcw size={16} />
            </span>

            <span
              className="cursor-pointer"
              onClick={() => navigate(`/student/view/${id}`)}
              title="Content View"
            >
              <FiEye size={16} />
            </span>
            <span
              className="cursor-pointer"
              onClick={() => navigate(`/student/library/${id}`)}
              title="Library"
            >
              <TbLibrary size={16} />
            </span>
          </div>
        );
      },
      meta: {
        headerClassName: "width-30",
        exportable: false,
      },
    },

    {
      accessorKey: "subscription_status",
      header: () => "Subscripton status",
      cell: (info) => {
        const row = info.row.original;
        const status = Number(row.subscription_status);

        const statusInfo = {
       0:{ text: "Pending", bg: "rgb(246, 244, 240)", color: "#c87b0f" },
          1:{ text: "Admin Approval Required", bg: "#f2ece6ff", color: "#ffa21d" },
           2: { text: "Approved", bg: "#cfe1f4ff", color: "rgb(14, 96, 110)" },
          3: { text: "Rejected", bg: "#ebd7dcff", color: "#dc3545" },
              4:{text:"Expired",bg:"#f6dedeff",color:"#000" }
        };
        const st = statusInfo[status] || {
          text: "Unknown",
          bg: "#e2e3e5",
          color: "#6c757d",
        };
        return (
          <span
            style={{
              display: "inline-block",
              padding: "4px 8px",
              borderRadius: "4px",
              fontWeight: "bold",
              backgroundColor: st.bg,
              color: st.color,
            }}
          >
            {st.text}
          </span>
        );
      },
      defaultIsVisible: true,
    },
    {
      accessorKey: "name",
      header: () => "Student Name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "phone",
      header: () => "phone",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "email",
      header: () => "email",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "otp_verify",
      header: () => "Email verified",
      cell: (info) => {
        const verify = info.getValue();
        return verify === 1 ? "Yes" : "No";
      },
      defaultIsVisible: true,
    },

    {
      accessorKey: "created_at",
      header: () => "created at",
      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },
  ];

  return (
    <>
      <Table data={saveData} columns={columns} />

      {selectedId && selectedStudent && (
        <ShowStatus
          show={showPopup}
          onClose={() => setShowPopup(false)}
          selectedId={selectedId}
          student={selectedStudent}
          currentStatus={status}
          onStatusChange={(id, newStatus) => {
            const fixedId = Number(id);
            const fixedStatus = Number(newStatus);

            setSaveData((prev) =>
              prev.map((item) =>
                Number(item.id) === fixedId
                  ? { ...item, subscription_status: fixedStatus }
                  : item
              )
            );

            setStatus(fixedStatus);
          }}
        />
      )}
    </>
  );
};

export default StudentTable;
